























/* General */
import Vue from 'vue'
import logoSrc from '@/assets/img/logos/logo-donedone.svg'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IItemForSelection } from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'RegistrationHeader',

  props: {
    steps: {
      type: Array as () => IItemForSelection[],
      default: [],
    },
    stepId: {
      type: Number,
      required: true,
    },
    disableStepClicks: {
      type: Boolean,
      default: false,
    },
    hideNav: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      logo: {
        src: logoSrc,
        alt: 'Logo DoneDone',
      },
      serverSideAppUrl: process.env.VUE_APP_SERVER_SIDE_APP_URL,
    }
  },

  methods: {
    isPreviousStepID(id: number): boolean {
      return id < this.stepId
    },
  },
})
